import { Action, createStore } from '@reduxjs/toolkit'
import { ThunkAction } from 'redux-thunk'
import rootReducer from './reducers'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage';

const myReducer = persistReducer({
  key: 'root',
  storage
}, rootReducer)

const store = createStore(myReducer)

export const persistor = persistStore(store)

export default store

export type AppDispatch = typeof store.dispatch

export type RootState = ReturnType<typeof rootReducer>

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>
